import { toTokens, toUnits } from "thirdweb";
import { Chains, ExchangeToken, ReservesType } from "./types";
import { decimals } from "./constants";

export const truncate = (value: string, length = 4) => {
    if (value.length <= 2 * length) {
        return value;
    }
    return `${value.slice(0, length)}\u2026${value.slice(-length)}`;
};

export const roundTokens = (tokens: bigint, decimals: number, roundTo: number) => {
    const roundedDec = BigInt(decimals - roundTo);
    const rounded = tokens / (10n ** roundedDec) * (10n ** roundedDec);
    return toTokens(rounded, decimals);
};

const mapping: Record<Chains, keyof ReservesType> = {
    Ethereum: "eth",
    Liberland: "ll",
    Solana: "sol",
    Tron: "trx",
};

export const displayReserve = (reserves: ReservesType, chain: Chains, token: ExchangeToken) => {
    const dec = decimals[chain][token];
    return roundTokens(reserves[mapping[chain]], dec, 2);
};

export const validateReserveAmount = (reserves: ReservesType, chain: Chains, fromAmount: string, token: ExchangeToken) => {
    const dec = decimals[chain][token];
    const reserve = reserves[mapping[chain]];
    return reserve >= toUnits(fromAmount, dec);
};
